export const SECTIONS = {
  ANCILLARIES_STAY: 'ancillaries_stay',
  ANCILLARIES_TRANSFER: 'ancillaries_transfer',
  ANCILLARIES_CAR_RENTAL: 'ancillaries_car_rental',
  ANCILLARIES_GUIDE: 'ancillaries_guide',
  ANCILLARIES_SKYCOP: 'ancillaries_skycop',
  BANNER_BLOCK: 'block_banner',
  BANNER_BILLBOARD: 'billboard_banner',
  DESTINATION_BOX: 'destination_box',
  CHECKIN_BOX: 'checkin_box',
  CHECKOUT_BOX: 'checkout_box',
  ROOM_IMAGES: 'room_images',
  ROOM_RATE: 'room_rate',
  ROOM_BOARD: 'room_board',
  HOTEL_IMAGES: 'hotel_images',
  PAXES_BOX: 'paxes_box',
  SEARCH_FILTERS: 'search_filters',
  RELATED: 'related',
  MAP_RESULTS: 'map_result',
  LIST_RESULTS: 'list_result_item',
  ROOM_OFFERS: 'room_offers',
  NO_ROOMS: 'no_rooms',
  SHOW_MORE_ROOMS: 'show_more_rooms',
  BANNER: 'banner',
  CHANGE_PAXES_DATES: 'change_paxes_dates',
  HOTELS_SEEN: 'hotels_seen',
  SUGGESTER: 'suggester',
  SUGGESTER_RESET: 'suggester_reset',
  SUGGESTION: 'suggestion',
  SUGGESTION_POPULAR_DES: 'suggestion_popular_destination',
  SUGGESTION_SEARCH_DES: 'suggestion_last_search_destination',
  CHATBOT: 'chatbot',
  SHARE_MODAL: 'share_modal',
  SHARE_MODAL_OPTION: 'share_modal_option',
  HOTEL_RATINGS: 'hotel_ratings',
  CAT_CHOOSE_ROOM_STEP: 'cta_choose_room_step',
  NAVIGATION_OVERVIEW: 'navigation_overview',
  NAVIGATION_FACILITIES: 'navigation_facilities',
  NAVIGATION_LOCATION: 'navigation_location',
  NAVIGATION_DETAILS: 'navigation_details',
  NAVIGATION_REVIEWS: 'navigation_reviews',
  NAVIGATION_CTA: 'navigation_cta',
  NAVIGATION_ROOMS: 'navigation_rooms',
  TOPBAR: 'topbar',
  TOP_DESTINATIONS: 'carousel_top_destinations',
  VIEW_COMMENTS: 'view_comments',
  HEADER: 'header',
  HOTEL_HEADER: 'hotel_header',
  HOTEL_DESCRIPTION: 'hotel_description',
  HOTEL_IMPORTANT_INFO: 'hotel_important_info',
  REVIEWS: 'reviews',
  BOARD_FILTERS_BREAKFAST: 'breakfast',
  BOARD_FILTERS_ALL_INCLUSIVE: 'all_inclusive',
  BOARD_FILTERS_PAY_LATER: 'pay_later',
  BOARD_FILTERS_FREE_CANCELLATION: 'free_cancellation',
  HOTEL_LIKE: 'hotel_like',
  INSURANCE_SELECTOR: 'insurance_selector',
  OMNISEARCH: 'omnisearch',
  TRAVEL_INSURANCE: 'travel_insurance',
  TRAVEL_INSURANCE_ESSENTIAL_SELECTED: 'insurance_essential',
  TRAVEL_INSURANCE_ADVANCED_SELECTED: 'insurance_advanced',
  TRAVEL_INSURANCE_COMPLETE_SELECTED: 'insurance_complete',
  TRAVEL_INSURANCE_NO_INSURANCE_SELECTED: 'no_insurance',
  VOUCHER_APP_BANNER: 'voucher_app_banner',
  VOUCHER_PAYMENT: 'voucher_payment',
} as const

export const PAGES = {
  LIST: 'hotel_list_results',
  HOME: 'homepage',
  DETAIL: 'hotel_details',
}

export const SECTION_KEYS = Object.values(SECTIONS)
export const PAGES_KEYS = Object.keys(PAGES)

export type SectionType = (typeof SECTION_KEYS)[number]
